import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const features = [{
  title: 'Next-Generation Rejuvenation',
  desc: 'Clear + Brilliant Touch represents the evolution of Clear + Brilliant, offering a gentler yet highly effective treatment compared to other fractional lasers. It combines the benefits of combined wavelengths in a single session, providing comprehensive skin rejuvenation.'
}, {
  title: 'Dual-Wavelength Precision',
  desc: 'By utilizing both the Original and Permea handpieces, Clear + Brilliant Touch targets both superficial and deeper skin layers. The Original laser addresses fine lines and dull skin tone, while the Permea treats sun damage and age spots.'
}, {
  title: 'Stimulated Collagen Production',
  desc: "The microchannels created by Clear + Brilliant Touch stimulate the body's wound-healing responses, leading to increased collagen production. This results in improved skin texture, firmness, and overall youthfulness."
}, {
  title: 'Minimal Discomfort, Maximum Results',
  desc: 'While patients may experience slight discomfort during treatment, Clear + Brilliant Touch is well-tolerated overall. Topical anesthetic is applied beforehand to enhance comfort, and the procedure typically lasts only 30-45 minutes.'
}];
export function CBNextGen() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-503">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-504">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-505">
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-506">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-507">
              <img src="https://cdn.magicpatterns.com/uploads/dmYtmyqQBF1LzSzzhViZfP/Clear-Brilliant-touch.jpg" alt="Clear + Brilliant Touch Laser Treatment" className="w-full h-full object-cover" data-id="element-508" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-509">
            <h2 className="text-[24px] lg:text-[36px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-510">
              NEXT-GENERATION REJUVENATION
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-511"></div>

            <div className="space-y-8" data-id="element-512">
              {features.map((feature, index) => <div key={index} data-id="element-513">
                  <h3 className="text-white text-lg font-bold font-[Poppins,_sans-serif] mb-2" data-id="element-514">
                    {feature.title}
                  </h3>
                  <p className="text-[#B0B0B0] text-[15px] leading-[1.7] font-body" data-id="element-515">
                    {feature.desc}
                  </p>
                </div>)}
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}